<template src='./tabAllotment.pug' lang='pug'></template>

<script>
import moment from 'moment'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import LoadingPlaceholder from '../../../loading/LoadingPlaceholder'
import language from '../../../../../build/language/index'
import { maskThousand } from '../../../../utils/numberMasker.js'
import PATHS from '../../../../router/routesMap.js'

moment.locale(language.getDatePickerLanguage())

export default {
  name: 'TabAllotment',

  components: {
    ButtonPrimary,
    LoadingPlaceholder
  },

  props: {
    // Prop enviada pelos relatórios de lançamentos.
    // Indica que as informações vêm dos movimentos bancários/financeiros.
    idMovimento: {
      type: String,
      default: null
    },

    // Prop enviada pelos relatórios de lançamentos.
    // Indica que as informações vêm dos movimentos bancários/financeiros.
    tipoMovimento: {
      type: String,
      default: null
    },

    // Prop enviada pela tela de conciliação manual.
    // Indica que as informações vêm da grid de lotes.
    dadosLote: {
      type: Object,
      default: null
    },

    getAllotment: {
      type: Function
    }
  },

  data () {
    return {
      loadingGif: require('../../../../assets/loading-gif/loading.svg'),
      columns: ['id', 'estabelecimento', 'dtLanc', 'vlMovFin', 'vlMovExt', 'cdOcu', 'dsOcu', 'nmConta', 'banco', 'nrConta', 'agencia'],
      options: {
        columnsClasses: {
          'id': 'col-1 limit-char',
          'estabelecimento': 'col-2 limit-char',
          'dtLanc': 'col-1 limit-char',
          'vlMovFin': 'col-2 limit-char',
          'vlMovExt': 'col-2 limit-char',
          'cdOcu': 'col-1 limit-char',
          'dsOcu': 'col-1 limit-char',
          'nmConta': 'col-1 limit-char',
          'banco': 'col-1 limit-char',
          'nrConta': 'col-1 limit-char',
          'agencia': 'col-1 limit-char'
        },
        headings: {
          id: this.$t('modalDetalhesLanc.tabLotes.labels.id'),
          estabelecimento: this.$t('estabelecimentos.labels.estabelecimento'),
          dtLanc: this.$t('modalDetalhesLanc.tabLotes.labels.dtLanc'),
          vlMovFin: this.$t('modalDetalhesLanc.tabLotes.labels.vlMovFinanc'),
          vlMovExt: this.$t('modalDetalhesLanc.tabLotes.labels.vlMovExtrato'),
          cdOcu: this.$t('modalDetalhesLanc.tabLotes.labels.codOcorrencia'),
          dsOcu: this.$t('modalDetalhesLanc.tabLotes.labels.dsOcorrencia'),
          nmConta: this.$t('modalDetalhesLanc.tabLotes.labels.nmConta'),
          banco: this.$t('modalDetalhesLanc.tabLotes.labels.banco'),
          nrConta: this.$t('modalDetalhesLanc.tabLotes.labels.nrConta'),
          agencia: this.$t('modalDetalhesLanc.tabLotes.labels.agencia')
        },
        templates: {
          id: (h, row) => {
            return row.id ? row.id : ' - '
          },
          dtLanc: (h, row) => {
            return moment(row.dataLancamento).utc().format('L')
          },
          vlMovFin: (h, row) => {
            return maskThousand(row.valorMovFin)
          },
          vlMovExt: (h, row) => {
            return maskThousand(row.valorMovBan)
          },
          cdOcu: (h, row) => {
            return row.motivoOcorrencia && row.motivoOcorrencia.codigo ? row.motivoOcorrencia.codigo : ' - '
          },
          dsOcu: (h, row) => {
            return row.motivoOcorrencia && row.motivoOcorrencia.descricao ? row.motivoOcorrencia.descricao : ' - '
          },
          nmConta: (h, row) => {
            return row.nomeConta ? row.nomeConta : ' - '
          },
          nrConta: (h, row) => {
            return row.numConta ? row.numConta : ' - '
          }
        },
        rowClassCallback: (row) => {
          let customClass = ''
          if (row.id && row.id === this.idMovimento) {
            customClass = 'selected-row'
          }
          return customClass
        },
        filterable: false,
        perPage: 10,
        perPageValues: [10, 20, 50, 100],
        texts: {
          count: this.$t('dataTable.labels.contagem'),
          noResults: this.$t('dataTable.labels.semResultados'),
          filterBy: '',
          filterPlaceholder: null,
          limit: this.$t('dataTable.labels.registrosPorPagina')
        },
        pagination: { chunk: 5 },
        sortable: ['id', 'estabelecimento', 'dtLanc', 'vlMovFin', 'vlMovExt', 'cdOcu', 'dsOcu', 'nmConta', 'banco', 'nrConta', 'agencia'],
        sortIcon: {
          is: ''
        }
      },
      hasAllotment: false,
      isLoadingData: true,
      allotment: {
        lancamentos: []
      },
      idLastLanc: null
    }
  },

  computed: {
    allotmentEntries () {
      return this.allotment && this.allotment.lancamentos ? this.allotment.lancamentos : []
    },
    allotmentId () {
      return this.allotment && this.allotment.idLote ? this.allotment.idLote : ' - '
    },
    allotmentQtdLanc () {
      return this.allotment.lancamentos ? this.allotment.lancamentos.length : ' - '
    },
    allotmentStatus () {
      return {
        valor: this.getStatusValueLabel(this.allotment.situacao),
        classe: this.getStatusValueClass(this.allotment.situacao)
      }
    },
    totalMovFin () {
      return this.allotment && this.allotment.totalMovFin ? this.allotment.totalMovFin : 0.00
    },
    totalMovExt () {
      return this.allotment && this.allotment.totalMovBan ? this.allotment.totalMovBan : 0.00
    },
    totalDivergencia () {
      return parseFloat(this.totalMovExt).toFixed(2) - parseFloat(this.totalMovFin).toFixed(2)
    },
    totalMovFinTransformed () {
      return maskThousand(this.totalMovFin)
    },
    totalMovExtTransformed () {
      return maskThousand(this.totalMovExt)
    },
    totalDivergenciaTransformed () {
      return maskThousand(this.totalDivergencia)
    },
    dateRangeAllotment () {
      return moment(this.allotment.dtInicio).utc().format('L') + ' - ' + moment(this.allotment.dtFim).utc().format('L')
    },
    canGoToManualConcil () {
      return this.totalDivergencia !== 0 && this.dadosLote === null
    },
    canConciliate () {
      return this.$store.getters.allowedFuncionalities && this.$store.getters.allowedFuncionalities.indexOf(199) >= 0
    },
    criteria () {
      return this.allotment && this.allotment.critConciliacao ? this.allotment.critConciliacao : '-'
    }
  },

  methods: {
    closeModal (idModal) {
      $('#' + idModal).modal('hide')
    },

    getStatusValueClass (item) {
      let title = ''
      switch (item) {
        case 'C':
          title = 'font-C'
          break
        case 'M':
          title = 'font-C'
          break
        case 'D':
          title = 'font-D'
          break
        case 'N':
          title = 'font-N'
          break
        case 'A':
          title = 'font-A'
          break
        default:
          title = ''
          break
      }
      return title
    },

    getStatusValueLabel (item) {
      let title = ''
      switch (item) {
        case 'C':
          title = this.$t('statusConciliacao.conciliado')
          break
        case 'M':
          title = this.$t('statusConciliacao.conciliadoManualmente')
          break
        case 'D':
          title = this.$t('statusConciliacao.divergente')
          break
        case 'N':
          title = this.$t('statusConciliacao.naoAplicavel')
          break
        case 'A':
          title = this.$t('statusConciliacao.aberto')
          break
        default:
          title = ' - '
          break
      }
      return title
    },

    loadAllotment () {
      if (!this.idLastLanc || (this.idLastLanc !== this.idMovimento)) {
        this.isLoadingData = true
        this.getAllotment(this.idMovimento).then((response) => {
          this.idLastLanc = this.idMovimento
          this.isLoadingData = false
          this.hasAllotment = response.data.idLote != null
          this.allotment = response.data
          this.setAllotmentRangeDate()
          this.setAllotmentMovCounts()
        }).catch((error) => {
          if (error.message) {
            this.$root.$refs.notification.error(error.message)
          } else {
            // Validação específica do parse dos dados
            this.$root.$refs.notification.error('modalDetalhesLanc.error.parseError')
          }
          this.isLoadingData = false
          this.hasAllotment = false
          this.allotment.lancamentos = []
          this.closeModal()
        })
      }
    },

    createAllotmentDetailsFromManualConcilaition () {
      if (!this.idLastLanc || (this.idLastLanc !== (this.dadosLote && this.dadosLote.idLote ? this.dadosLote.idLote : -1))) {
        this.isLoadingData = true
        this.$store.dispatch('recoverAllotmentMov', this.dadosLote.idLote).then((response) => {
          this.idLastLanc = this.dadosLote.idLote
          this.isLoadingData = false
          this.hasAllotment = this.dadosLote.idLote != null
          this.allotment = this.dadosLote
          this.allotment.countMovFin = response.financialMovements ? response.financialMovements.length : 0
          this.allotment.countMovBan = response.bankMovements ? response.bankMovements.length : 0
          this.allotment.lancamentos = []
          response.financialMovements.forEach(movFin => {
            let item = {
              id: movFin.id,
              dataLancamento: movFin.data,
              valorMovFin: movFin.valor,
              valorMovBan: 0,
              estabelecimento: movFin.estabelecimento,
              motivoOcorrencia: {
                codigo: movFin.cdOcorrencia,
                descricao: movFin.dsOcorrencia
              },
              nomeConta: movFin.nomeConta,
              banco: movFin.banco,
              numConta: movFin.numConta,
              agencia: movFin.agencia
            }
            this.allotment.lancamentos.push(item)
          })
          response.bankMovements.forEach(movBan => {
            let item = {
              id: movBan.id,
              dataLancamento: movBan.data,
              valorMovFin: 0,
              valorMovBan: movBan.valor,
              estabelecimento: movBan.estabelecimento,
              motivoOcorrencia: {
                codigo: movBan.cdOcorrencia,
                descricao: movBan.dsOcorrencia
              },
              nomeConta: movBan.nomeConta,
              banco: movBan.banco,
              numConta: movBan.numConta,
              agencia: movBan.agencia
            }
            this.allotment.lancamentos.push(item)
          })
        }).catch((error) => {
          if (error.message) {
            this.$root.$refs.notification.error(error.message)
          } else {
            // Validação específica do parse dos dados
            this.$root.$refs.notification.error('modalDetalhesLanc.error.parseError')
          }
          this.closeModal('detalhesLoteConcManual')
          this.hasAllotment = false
          this.allotment.lancamentos = []
        })
      }
    },

    goManualConcil () {
      // Abre tela de conciliação manual em nova aba
      window.open(PATHS.MANUAL_CONCILIATION, '_blank')
    },

    // Normaliza os dados de datas da aba da modal de lançamentos
    // para estrutura reutilizável para lotes
    setAllotmentRangeDate () {
      let startDate = new Date('01/01/9999')
      let endDate = new Date('01/01/1900')
      this.allotment.lancamentos.forEach(entry => {
        let date = entry.dataLancamento ? entry.dataLancamento : entry.data
        if (moment(date).isBefore(startDate)) {
          startDate = date
        }
        if (moment(date).isAfter(endDate)) {
          endDate = date
        }
      })

      this.allotment.dtInicio = startDate
      this.allotment.dtFim = endDate
    },

    // Normaliza os dados de contadores de movimentos da aba da modal
    // de lançamentos para estrutura reutilizável para lotes
    setAllotmentMovCounts () {
      let finCount = 0
      let banCount = 0
      this.allotment.lancamentos.forEach(mov => {
        mov.banco !== ' - '
        ? banCount++
        : finCount++
      })
      this.allotment.countMovFin = finCount
      this.allotment.countMovBan = banCount
    }
  }
}
</script>

<style>
@media screen and (min-width: 1199px) {
  .left-vertical-tabs {
    width: 10%;
  }

  .right-text-tabs {
    width: 90%;
  }
}

@media screen and (min-width: 992px) and (max-width: 1199px) {
  .left-vertical-tabs {
    width: 15%;
  }

  .right-text-tabs {
    width: 85%;
  }
}

@media screen and (max-width: 991px) and (min-width: 560px) {
  .left-vertical-tabs {
    width: 20%;
  }

  .right-text-tabs {
    width: 80%;
  }
}

@media screen and (max-width: 559px) {
  .left-vertical-tabs {
    width: 25%;
  }

  .right-text-tabs {
    width: 75%;
  }
}

#btnTabLoteConcManualDivergence {
  margin-bottom: 10px;
  margin-top: 0px;
  min-width: auto;
  width: 26px;
  height: 26px;
  padding: 0px 0px 0px 1px;
}

#tab-allotment-id {
  margin: 0px;
  overflow: hidden;
  width: 100%;
  font-family: 'Inter', sans-serif;
}

.loadingData {
  background: url(../../../../assets/loading-gif/loading.svg) 50% 50% no-repeat;
  cursor: wait;
  height: 390px;
  background-size: 100px;
}

.limit-char {
  white-space: nowrap;
  text-overflow: ellipsis;
}

.no-allotment-img {
  height: 30vh;
}

.big-txt-allotment {
  font-family: 'Inter', sans-serif !important;
font-weight: 700;
  color: #012351;
  font-size: 21px;
  margin: 1.5vh auto;
}

.grid-modal-content {
  padding: 5px 10px 0px 10px;
  min-height: 47vh;
  min-width: 47vw;
}

.detail-value-allotment {
  font-family: 'Inter', sans-serif;
font-weight: 700;
  color: #012351;
  font-size: 18px;
}

.detail-status-allotment {
  font-family: 'Inter', sans-serif;
font-weight: 700;
  font-size: 26px;
}

.detail-title-allotment {
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  margin-top: 1vh;
  color: #012351;
}

#tab-allotment-id.modal-footer {
  padding: 0px;
}

#main-allotment-container.main-container {
  max-height: 50vh;
  overflow: auto;
}

#datatable-container .allotment-data-table {
  display: flex;
  flex-flow: row wrap;
  max-width: 100%;
  max-height: 38vh !important;
  overflow-x: hidden;
  overflow-y: auto;
}

.font-C {
  color: #3bb57a !important;
}

.font-D {
  color: #f55753 !important;
}

.font-N {
  color: #56a9c1 !important;
}

.font-A {
  color: #fdbd39 !important;
}

.font-default {
  color: #17375f !important;
}

.col-1 {
  width: 3vw;
  font-size: 12px;
}

.col-2 {
  width: 7vw;
  font-size: 12px;
}

.selected-row {
  background-color: #617a95 !important;
  color: #fff;
}

.margin-container {
  margin-top: 15px;
}

.monetary-container {
  background: #eff0f3;
  border: 1px solid #DDD;
  margin-top: 15px;
  padding: 15px;
}

.loading-center {
  text-align: center;
  margin-bottom: 60px;
}

.detail-allotment-value {
  font-family: 'Inter', sans-serif;
  font-weight: bold;
  color: #012351;
  font-size: 14px;
}

.VueTables__sortable > span.VueTables__heading {
  padding-right: 15px;
}

.VueTables__table .VueTables__sort-icon.glyphicon::before {
  top: 1px;
  position: absolute;
  left: -10px;
}

#datatable-container .VueTables .row {
  order: 3;
  margin: 12px 0 0;
  padding: 0;
}

#datatable-container .VueTables .row .VueTables__limit {
  margin: 0;
}

#datatable-container .VueTables .row .VueTables__limit label{
  text-transform: initial;
  font-weight: normal;
  font-size: 14px;
  margin-right: 10px;
}

#datatable-container .VueTables .table-responsive {
  order: 1;
}

#datatable-container .VueTables .VuePagination {
  flex: 1;
  order: 2;
  margin-top: 12px;
}

#datatable-container .VueTables .VuePagination nav {
  display: flex;
  align-items: center;
}

#datatable-container .VueTables .VuePagination nav ul {
  order: 2;
  margin: 0 auto;
}

#datatable-container .VueTables .VuePagination nav p {
  order: 1;
  width: auto;
  padding: 0;
  margin: 0;
}

.tab-allotment-detail-id {
  min-height: 71vh !important;
}
</style>



// WEBPACK FOOTER //
// TabAllotment.vue?16b0f11a